<template>
	<o-section
		class="organization-fusion-request-modal"
		title="Demande de fusion">
		<div class="organization-fusion-request-modal__subtitle">
			Intégrez les sociétés d'une autre organisation afin de compléter la vôtre et de travailler sous un référentiel unique.
		</div>

		<o-alert
			class="organization-fusion-request-modal__alert"
			color="info">
			<p>
				<o-icon font-icon="icon-interface-alert-information-circle"/>
				En réalisant cette demande de fusion, le créateur de l'organisation ciblée sera invité à accepter ou refuser.
			</p>
			<p>S'il accepte, l’organisation cible sera entièrement <b>intégrée à la vôtre</b>.</p>
			<p>
				Les rôles, tags, utilisateurs et l'ensemble des documents de l'organisation fusionnée
				feront partie intégrante de votre organisation.
			</p>
		</o-alert>

		<div>
			<strong>Quelle organisation souhaitez-vous intégrer ?</strong>
			<div class="organization-fusion-request-modal__inputs">
				<o-input
					:ref="setup._cleanSearch"
					v-model="setup.cleanSearch"
					class="organization-fusion-request-modal__search"
					:donetyping="600"
					label="Email de l'organisation cible"
					@input="setup.searchOrganizationByMailAsync()"
					@keydown="setup.handleKeydownGuard($event)"/>
				<o-input
					:model-value="setup.organizationMailSuffix"
					disabled
					class="organization-fusion-request-modal__mail-suffix"/>
			</div>
		</div>

		<o-alert
			v-if="setup.noResultForSearch"
			color="warning">
			Aucun résultat pour : "{{ setup.search }}"
		</o-alert>

		<div
			v-if="setup.selectedSearchedOrganization"
			class="organization-fusion-request-modal__preview">
			<div class="organization-fusion-request-modal__organization">
				<p class="organization-fusion-request-modal__organization-self">
					<span class="organization-fusion-request-modal__organization-label">L'organisation :</span>
					{{ setup.selectedSearchedOrganization?.name }}
					<o-icon
						font-icon="icon-interface-delete-1"
						ripple="danger"
						@click="setup.clearSelectedSearchAndSearch()"/>
				</p>
			</div>

			<div class="organization-fusion-request-modal__fusion-label">
				Sera fusionnée à
				<o-icon font-icon="icon-interface-arrows-move-right"/>
			</div>

			<div class="organization-fusion-request-modal__organization">
				<div>
					<p class="organization-fusion-request-modal__organization-self">
						<span class="organization-fusion-request-modal__organization-label">Votre organisation :</span>
						{{ setup.self.organization?.name }}
					</p>
				</div>
			</div>
		</div>

		<div v-if="setup.self.organization?.id">
			<o-button
				v-if="setup.selectedSearchedOrganization"
				color="brand"
				block
				@click="setup.sendAskFusionAsync()">
				Demander la fusion
			</o-button>
			<o-button
				color="danger"
				block
				outline
				@click="_modal?.close()">
				Annuler
			</o-button>
		</div>
		<o-alert
			v-else
			color="warning">
			Pour effectuer une demande de fusion vous devez d'abord créer votre propre organisation.
		</o-alert>
	</o-section>
</template>

<script setup lang="ts">
import OrganizationFusionRequestModalSetupService from '@/setup/organization/OrganizationFusionRequestModalSetupService';
import { inject } from 'vue';
const _modal = inject<OrionModal>('_modal');
const props = defineProps(OrganizationFusionRequestModalSetupService.props);
const setup = new OrganizationFusionRequestModalSetupService(props, _modal);
</script>

<style scoped lang="less">
.organization-fusion-request-modal {
  :deep(.orion-section__content) {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  &__subtitle {
    color: var(--grey-dark);
  }

  &__alert {
    .orion-icon {
      float: right;
      margin: 0.25rem 0rem 0.5rem 0.75rem;
      font-size: 1.25rem;
    }
  }

	&__inputs {
		position: relative;
		display: flex;
		align-items: center;
		gap: 10px;
		.orion-input + .orion-input {
			margin: unset;
		}
	}

  &__search {
    flex: 3;
		.orion-input__input {
			background: transparent;
		}
  }

	&__mail-suffix {
		position: absolute;
		max-width: 8rem;
		right: 0;

		.orion-input__input {
			border: transparent;
		}
	}

  &__organization {
    border-radius: 0.25rem;
    display: flex;
    align-items: center;
    padding: 0.5rem 0.75rem;
    background: var(--grey-lighter);
  }

  &__organization-label {
    &--empty {
      display: block;
      text-align: center;
      color: var(--grey);
    }
  }

  &__fusion-label {
    padding: 1rem;
    color: var(--grey-dark);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;

    .orion-icon {
      margin-left: 0.5rem;
      font-size: 1rem;
      transform: rotate(90deg);
      color: var(--grey-darker);
    }
  }

  &__organization-self {
		position: relative;
		width: 100%;
    display: flex;
    align-items: center;
    margin: unset;
    line-height: 24px;
    color: var(--grey-darker);
    font-weight: 700;

    .organization-fusion-request-modal__organization-label {
      margin-right: 10px;
      color: var(--grey-dark);
      font-weight: 400;
    }

		.orion-icon {
			position: absolute;
			right: 10px;
			font-size: 10px;
		}
  }

  .orion-button {
    + .orion-button {
      margin-top: 16px;
    }
  }
}
</style>
